import { render, staticRenderFns } from "./detalhe_novo_paciente_dashboard.vue?vue&type=template&id=6f862d82&scoped=true&"
import script from "./detalhe_novo_paciente_dashboard.vue?vue&type=script&lang=js&"
export * from "./detalhe_novo_paciente_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./detalhe_novo_paciente_dashboard.vue?vue&type=style&index=0&id=6f862d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f862d82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VIcon,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
